import { render, staticRenderFns } from "./addgameMg.vue?vue&type=template&id=328a57e8&"
import script from "./addgameMg.vue?vue&type=script&lang=js&"
export * from "./addgameMg.vue?vue&type=script&lang=js&"
import style0 from "./addgameMg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('328a57e8')) {
      api.createRecord('328a57e8', component.options)
    } else {
      api.reload('328a57e8', component.options)
    }
    module.hot.accept("./addgameMg.vue?vue&type=template&id=328a57e8&", function () {
      api.rerender('328a57e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/googleAds/components/addgameMg.vue"
export default component.exports